import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '../Button';
import colors from '../../styles/colors';
import EnterNewContactModal from './EnterNewContactModal';
import ImportContactListModal from './ImportContactListModal';

const Container = styled.div`
  padding: 20px 15px;
`;

const Text = styled.div`
  font-size: 1.4rem;

  color: ${colors.grey3};
`;

const ModalStates = Object.freeze({
  Options: 'Options',
  Csv: 'Csv',
  Manual: 'Manual',
});

const ImportContactOptionModal = ({ setModalState }) => (
  <Container>
    <Text>How would you like to add your contacts?</Text>
    <Button
      margin="30px 0px 0px 0px"
      text="ENTER CONTACTS MANUALLY"
      width="100%"
      onClick={() => setModalState(ModalStates.Manual)}
    />
    <Button
      margin="20px 0px 0px 0px"
      text="UPLOAD CONTACTS FROM CSV FILE"
      width="100%"
      onClick={() => setModalState(ModalStates.Csv)}
    />
  </Container>
);

export default function ImportContactsModal({
  setReferrers,
  setSearchQuery,
  close,
}) {
  const [modalState, setModalState] = useState(ModalStates.Options);

  switch (modalState) {
    case ModalStates.Options:
      return <ImportContactOptionModal setModalState={setModalState} />;
    case ModalStates.Manual:
      return (
        <EnterNewContactModal
          setSearchQuery={setSearchQuery}
          setReferrers={setReferrers}
          close={close}
        />
      );
    case ModalStates.Csv:
      return <ImportContactListModal close={close} />;
    default:
      return null;
  }
}
